import { Card } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import StudyListManageGrid from "../../app/study-list/StudyListManageGrid";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import AppConfig from "../../core/service/AppConfig";

export default function StudyListPage() {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = `${t('My Lists')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        // Filtre paneli yok ama sarmalayıcı yine LayoutWithSider: içerik kutusunun sabit header
        // ve footer'dan kaçınan margin'leri ORADA tanımlı. Sarmalayıcısız haliyle sayfa
        // header'ın altına giriyordu.
        <LayoutWithSider fullWidth={true}>
            <Card title={t('My Lists')}>
                <StudyListManageGrid />
            </Card>
        </LayoutWithSider>
    )
}
